import React, { useState } from "react";
import { Modal, Checkbox, Input } from "antd";
import { toast } from "react-toastify";
import { customLogger } from "../../../../utils/Logger";
import ENDPOINTS from "../../../../services/endpoint";
import apiInstance from "../../../../services/apiService";
import GradientButton from "../../../common/UI/GradientButton";
import "./index.scss";

interface AddNewModalProps {
  visible: boolean;
  onClose: () => void;
  onAfterClose: () => void;
}

const AddNewModal: React.FC<AddNewModalProps> = ({
  visible,
  onClose,
  onAfterClose,
}) => {
  const [selectedOptions, setSelectedOptions] = useState<string[]>([]);
  const [loading, setLoading] = useState(false);
  const [phoneNumber, setCurrentPhoneNumber] = useState<any>(null);

  const handleCheckboxChange = (checkedValues: string[]) => {
    setSelectedOptions(checkedValues);
  };

  const handleCreate = async () => {
    if (
      phoneNumber.length > 13 ||
      /[a-zA-Z]/.test(phoneNumber.replace(/^\+/, ""))
    ) {
      toast.error("Please enter a valid phone number");
      return;
    }
    const url = ENDPOINTS.BLOCK_NUMBER;

    setLoading(true);

    try {
      const response = await apiInstance.post(url, {
        phoneNumber: phoneNumber,
        calls: selectedOptions.includes("calls"),
        sms: selectedOptions.includes("sms"),
      });

      if (response.status === 200) {
        toast.success("Phone Number Added successfully!");
        onClose();
      }
    } catch (error) {
      customLogger(error);
      toast.error("There was an error. Please try again");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title="Block Number"
      open={visible}
      onCancel={onClose}
      afterClose={onAfterClose}
      footer={null}
      centered
      width={300}
      className="block-number-modal custom-modal"
    >
      <Input
        className="number-input"
        value={phoneNumber}
        onChange={(e) => setCurrentPhoneNumber(e.target.value)}
      />
      <Checkbox.Group
        value={selectedOptions}
        onChange={handleCheckboxChange}
        className="block-options"
      >
        <Checkbox value="calls">Call</Checkbox>
        <Checkbox value="sms">SMS</Checkbox>
      </Checkbox.Group>
      <GradientButton
        loading={loading}
        onClick={handleCreate}
      >
        Block
      </GradientButton>
    </Modal>
  );
};

export default AddNewModal;
